(function (M) {
  if (!M) return;
  var d = document, sc = d.querySelector('.sc');
  if (!sc) return;
  var hero = sc.querySelector('.sc-hero'), bottle = hero && hero.querySelector('.bottle');
  if (bottle) {
    var B = M.narrow
      ? [[30, 10, 7, 8], [42, 6, 6, -6], [58, 12, 8, 7], [70, 7, 6.5, -8], [36, 8, 9, 6], [64, 9, 7.5, -5]]
      : [[33, 12, 8, 10], [38, 7, 6.5, -8], [42, 16, 9.5, 12], [45, 6, 7, -6], [55, 9, 7.5, 8], [58, 14, 9, -10],
         [62, 7, 6, 7], [67, 11, 8.5, -9], [28, 8, 10, 6], [72, 10, 9, -7], [48, 5, 6.5, 5], [52, 13, 10.5, -8]];
    var h = '';
    B.forEach(function (b, i) {
      h += '<i style="--x:' + b[0] + '%;--s:' + b[1] + 'px;--t:' + b[2] + 's;--w:' + b[3] + 'px;--dl:-' + (i * 0.83).toFixed(2) + 's"></i>';
    });
    bottle.insertAdjacentHTML('beforebegin', '<div class="sc-bubbles mo-deco" aria-hidden="true">' + h + '</div>');
    bottle.classList.add('sc-in');
  }
  M.tag('.sc-hero .cap > *', 'up', { d: 0.35, step: 0.14 });
  M.tag('.sc-tech h2, .sc-tech p.lead', 'up', { step: 0.12 });
  M.tag('.sc-stat', 'up', { d: 0.2, step: 0.12 });
  var stat = sc.querySelector('.sc-stat b');
  if (stat) M.count(stat, '520');
  M.tag('.sc-art', 'zoom', { d: 0.1 });
  var pills = sc.querySelector('.sc-art .pills');
  if (pills) pills.classList.add('mo-float');
  M.tag('.sc-price', 'fade', { d: 0.3 });
  var hex = sc.querySelector('.sc-hex');
  if (hex) {
    hex.setAttribute('data-mo-play', '');
    ['b1', 'b2', 'b4', 'b6', 'b5', 'b3'].forEach(function (c, i) {
      var b = hex.querySelector('.bub.' + c);
      if (b) b.style.setProperty('--sc-d', (0.45 + i * 0.18).toFixed(2) + 's');
    });
  }
  M.tag('.sc-fda', 'fade');
  M.tag('.sc-suit h2, .sc-suit p', 'up', { step: 0.12 });
  var suit = sc.querySelector('.sc-suit p');
  if (suit) M.count(suit, '875');
  var sharkBg = sc.querySelector('.sc-low .shark-bg');
  if (sharkBg) sharkBg.setAttribute('data-mo-par', '70');
  M.tag('.sc-buy .jpl', 'fade');
  M.tag('.sc-buy .g > img', 'left');
  M.tag('.sc-buy .g > div', 'up', { d: 0.15 });
  M.tag('.sc-brand .circ img', 'zoom');
  var badge = sc.querySelector('.sc-50 b');
  if (badge) {
    badge.classList.add('sc-ringed');
    badge.setAttribute('data-mo-play', '');
    badge.insertAdjacentHTML('afterbegin', '<svg class="sc-ring mo-deco" viewBox="0 0 62 62" aria-hidden="true"><circle cx="31" cy="31" r="29.5" pathLength="1"/></svg>');
    M.count(badge, '50');
  }
  var since = sc.querySelector('.sc-since span');
  if (since) since.setAttribute('data-mo-drift', '60');
  M.tag('.sc-since', 'fade');
  M.tag('.sc-brand h2, .sc-brand p, .sc-brand .certs', 'up', { step: 0.12 });
})(window.FJKMotion);
